import useCompanyCardQuery from "app/pages/sales-intelligence/modules/company-analysis/queries/useCompanyCardQuery";
import { is } from "app/pages/sales-intelligence/utils/type-guards";

import CompanyCardContent from "../../../components/cards/company-card/CompanyCardContent/CompanyCardContent";
import CompanyCardEmpty from "../../../components/cards/company-card/CompanyCardEmpty/CompanyCardEmpty";
import Card from "../../../components/shared/Card/Card";

const CompanyCard = () => {
    const { data, isFetching, isFetched } = useCompanyCardQuery();
    const isEmpty = !data && isFetched;

    const renderContent = () => {
        if (is.undefined(data) || isEmpty) {
            return <CompanyCardEmpty />;
        }

        return <CompanyCardContent data={data} />;
    };

    return (
        <Card
            dataAutomation="company-card"
            renderContent={renderContent}
            isLoading={isFetching}
        />
    );
};

export default CompanyCard;
